<template>
  <div>
    <b-row>
      <b-col xs="12">
        <date-filter :namespace="namespace"></date-filter>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col md="6">
        <rest-point-filter :namespace="namespace"></rest-point-filter>
      </b-col>
      <b-col md="6">
        <delivery-type-filter :namespace="namespace"></delivery-type-filter>
      </b-col>
    </b-row>
    <div class="d-flex mb-2 mt-3">
      <h4 class="mt-0 mr-3">Статистика выполнения заказов по промежуткам</h4>
      <b-spinner v-if="timeOrderLoading" class=""></b-spinner>
    </div>
    <b-table v-bind="tableProps">
      <div slot="table-busy" class="text-center">
        <strong>Загрузка статистики...</strong>
      </div>
      <template slot="timeTo" slot-scope="data">
        {{getIntervalTitle(data.item)}}
      </template>
      <template slot="percentCount" slot-scope="data">
        {{data.value ? (data.value * 100).toFixed(2) + ' %' : ''}}
      </template>
      <template slot="percentSum" slot-scope="data">
        {{data.value ? (data.value * 100).toFixed(2) + ' %' : ''}}
      </template>
      <template slot="FOOT_count">
        {{countTotal}}
      </template>
      <template slot="FOOT_sum">
        {{sumTotal}}
      </template>
    </b-table>
  </div>
</template>

<script>

import {orderTimeGetters as otGetter} from '../constants/vuexGetters'
import DateFilter from './DateFilter'
import RestPointFilter from './RestPointFilter'
import DeliveryTypeFilter from './DeliveryTypeFilter'
import {timeOrderPercentCalc} from '../helpers/timeOrdersPercentCalc'
import ACT, {orderWorkshopACT as owACT} from '../constants/vuexActions'

export default {
  name: 'StatsOrderCompletion',
  data: () => {
    return {
      namespace: 'admin/orderTimeStats'
    }
  },
  computed: {
    timeOrderLoading () {
      return this.getter(otGetter.LOADING_STATS_TIME_ORDER)
    },
    timeOrderStats () {
      return this.getter(otGetter.STATS_TIME_ORDER)
    },
    timeOrderItems () {
      return timeOrderPercentCalc(this.timeOrderStats)
    },
    tableProps () {
      return {
        striped: true,
        busy: this.loading,
        showEmpty: true,
        bordered: true,
        footClone: this.timeOrderStats.length !== 0,
        emptyText: 'Заказов за выбранный период не найдено',
        class: 'table-main',
        items: this.timeOrderItems,
        fields: [
          {
            key: 'timeTo',
            label: 'Период'
          },
          {
            key: 'count',
            label: 'Кол-во'
          },
          {
            key: 'sum',
            label: 'Сумма'
          },
          {
            key: 'percentCount',
            label: '% Кол-во'
          },
          {
            key: 'percentSum',
            label: '% Суммы'
          }
        ]
      }
    },
    countTotal () {
      return this.timeOrderItems.reduce((accum, item) => accum + item.count, 0)
    },
    sumTotal () {
      return this.timeOrderItems.reduce((accum, item) => accum + item.sum, 0)
    }
  },
  methods: {
    getter (getter) {
      return this.$store.getters[`${this.namespace}/${getter}`]
    },
    dispatch (action, payload) {
      this.$store.dispatch(`${this.namespace}/${action}`, payload)
    },
    stateVar (variable) {
      return this.$store.state.admin.orderTimeStats[variable]
    },
    commit (query, payload) {
      this.$store.commit(`${this.namespace}/${query}`, payload)
    },
    getIntervalTitle (item) {
      let prop = item.timeTo
      if (prop) {
        let durObj = this.$moment.duration(prop, 'minutes')
        let hours = durObj.hours()
        let minutes = ('0' + durObj.minutes()).slice(-2)
        return `< ${hours}:${minutes}`
      } else {
        return 'Более'
      }
    }
  },
  components: {
    DateFilter,
    RestPointFilter,
    DeliveryTypeFilter
  },
  created () {
    this.$store.dispatch(`${this.namespace}/${owACT.REQUEST_INIT_DATA}`).then(res => {
      this.$store.dispatch(`${this.namespace}/${ACT.REQUEST_STATS}`)
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/StatsOrderCompletion.vue